import CryptoJS from "crypto-js";

const secretPass = process.env.REACT_APP_SECRET_PASS;

const encryptData = (text) => {
  try {
    const data = CryptoJS.AES.encrypt(
      JSON.stringify(text),
      secretPass
    ).toString();
    return data;
  } catch (error) {
    console.log("encryptData error");
    return text;
  }
};

const decryptData = (text) => {
  try {
    const bytes = CryptoJS.AES.decrypt(text, secretPass);
    const data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return data;
  } catch (error) {
    console.log("decryptData error");
    return text;
  }
};

export { encryptData, decryptData };
